import { add as addRequest } from 'serviceWorker/db/httpRequests';
import {
  HttpRequestModelType,
  HttpRequestStatus,
} from 'shared/domain/httpRequest/httpRequestModel';
import { InspectionTemplateOutDto } from 'shared/dtos/out/template';
import { InspectionTemplateHttpEditRequestModel } from '../httpQueue/inspectionTemplate/types';

export class InspectionTemplateEditor {
  constructor(
    private addRequest: (
      request: InspectionTemplateHttpEditRequestModel
    ) => Promise<unknown>
  ) {}

  async execute(
    templateId: string,
    inspectionTemplateOutDto: Partial<InspectionTemplateOutDto>,
    projectId: string,
    uniqueId: string
  ): Promise<void> {
    await this.addRequest({
      createdAt: Date.now(),
      method: 'PUT',
      data: {
        inspectionTemplateOutDto,
        uniqueId,
      },
      url: `/project/${projectId}/inspectionTemplate/${templateId}`,
      entityType: HttpRequestModelType.inspectionTemplate,
      status: HttpRequestStatus.NEW,
    });
  }
}

export const inspectionTemplateEditor = new InspectionTemplateEditor(
  addRequest
);
